import { component$ } from "@builder.io/qwik";

interface MidListCTAProps {
  breakdownName: string;
  breakdownTypeSlug: string;
  ctaLinkTextTemplate: string;
  preLinkText: string;
  utmCampaignPrefix: string;
}

export const MidListCTA = component$<MidListCTAProps>(
  ({
    breakdownName,
    breakdownTypeSlug,
    ctaLinkTextTemplate,
    preLinkText,
    utmCampaignPrefix,
  }) => {
    const ctaLinkText = ctaLinkTextTemplate.replace("{}", breakdownName);

    return (
      <div class="bg-brand-50 border-brand-100 my-6 flex items-center justify-center gap-2 rounded-lg border py-4 text-center sm:col-span-2 lg:col-span-3">
        <p class="text-primary">{preLinkText}</p>
        <a
          href={`/discovery?utm_campaign=${utmCampaignPrefix}&utm_source=${breakdownTypeSlug}`}
          class="text-brand-700 hover:text-brand-800 text-base underline transition-colors hover:no-underline"
        >
          {ctaLinkText}
        </a>
      </div>
    );
  },
);

export default MidListCTA;
